/*======================================================================================================================
  * Bluebell: src/app/state/text-columns/text-columns.reducer.ts
  * Last Edited: 29/07/2025
  * Copyright 2025 Bramble CFD LTD
  * The contents of this file are NOT for redistribution
  * See AUTHORS for list of developers on this project
 =====================================================================================================================*/
import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { programmeProjectSelectionUnapplied } from '@state/account/account.actions';
import {
  createTextColumnSuccess, deleteTextColumnSuccess,
  listTextColumns,
  listTextColumnsFailure,
  listTextColumnsSuccess, updateTextColumnSuccess,
} from '@state/text-columns/text-columns.actions';
import { TextColumn } from '@state/text-columns/text-columns.interfaces';


export interface State extends EntityState<TextColumn> {
  loading: boolean;
}

export const adapter = createEntityAdapter<TextColumn>({
  selectId: (column: TextColumn) => column.uuid
});

export const initialState = adapter.getInitialState<State>({
  loading: false,
});

export const reducer = createReducer(
  initialState,

  on(programmeProjectSelectionUnapplied, () => {
    return adapter.removeAll({ ...initialState });
  }),

  on(listTextColumns, (state) => {
    return { ...state, loading: true };
  }),

  on(listTextColumnsSuccess, (state, { columns }) => {
    return adapter.setAll(columns, { ...state, loading: false });
  }),

  on(listTextColumnsFailure, (state) => {
    return { ...state, loading: false };
  }),

  on(
    createTextColumnSuccess,
    updateTextColumnSuccess,
    (state, { column }) => {
    return adapter.upsertOne(column, state);
  }),

  on(deleteTextColumnSuccess, (state, { uuid }) => {
    return adapter.removeOne(uuid, state);
  }),
);

export const featureKey = 'textColumns';
export const {
  selectIds: getIds,
  selectEntities: getEntities,
  selectAll: getAll,
  selectTotal: getCount,
} = adapter.getSelectors();
export const getLoading = (state: State) => state.loading;
